var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('masonry',{attrs:{"cols":{default: 3, 1000: 2, 400: 1},"gutter":{default: '10px', 700: '5px'}}},_vm._l((_vm.albums),function(object,key){return _c('progressive-img-link',{key:key,attrs:{"id":"pimg","src":_vm.getAlbumSrc(key, 1),"alt":object.name,"placeholder":_vm.getImagePlaceholder(key, 1),"url":("/album/" + key)}})}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77af2722","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Gallery.vue
// module id = null
// module chunks = 